import { useActionRight } from "./useActionRight";
import { shouldHideFormActionList } from "../helpers/formReadOnly";

export const useHideFormActionList = (form) => {
  const { pageAccessRight } = useActionRight();
  return shouldHideFormActionList(form, pageAccessRight);
};
